import styles from './Model.module.css';

const Model = ({
    value,
    onUpdateInfoField,
}: {
    value: string;
    onUpdateInfoField: (value: any) => void;
}) => {
    return (
        <div className={styles.model}>
            <label className={`${styles.infoLabel} ${styles.required}`}>
                Model name
            </label>
            <input
                type="text"
                placeholder="Enter model name"
                value={value}
                onChange={(e) => onUpdateInfoField(e.target.value)}
            />
        </div>
    );
};

export default Model;
